const Ans = ({answer}) => {
    return(
        <div>
            {answer}             
        </div>
    )
}

export default Ans;